import { FC, useState, FormEvent } from 'react';
import { useStyles, cardStyle } from './styles';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useStore } from 'hooks/useRootStore';
import { useHistory } from 'react-router-dom';
import { useStripe, CardNumberElement, CardExpiryElement, CardCvcElement, useElements } from '@stripe/react-stripe-js';
import { StripeCardNumberElement } from '@stripe/stripe-js';
import { Button, FormControl, FormLabel, Grid, TextField } from '@material-ui/core';
import { FormGroup } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { CardType } from './types';
import { useMutation, useQuery } from 'react-query';
import { BillingInput } from '../UpgradeLicenseForm';
import CardPreview from '../CardPreview/CardPreview';
import { toFormatSum } from 'utils';
export const CardForm: FC<CardType> = ({
  previewType,
  numberOfUsers,
  coreCheckHandle,
  addonCheckHandle,
  corePrice,
  addonPrice,
  finalAmount,
  userAddon,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const {
    upgradeLicenseStore: { invoice, billingDetail, getCoreInfo, stripeResponce },
    notificationStore: { openNotification },
  } = useStore();
  const [processing, setProcessing] = useState<boolean>(false);
  const stripe = useStripe();
  const elements = useElements();
  const [cardName, setCardName] = useState<string>('');
  const [cardaddress, setCardAddress] = useState<string>('');
  const [emails, setInvoiceEmail] = useState<string>('');
  const [valid, setValid] = useState<any>();
  const stripeRespDetail = useMutation((data: any) => stripeResponce(data));
  const billingDetailReq = useMutation((data: BillingInput) => billingDetail(data), {
    mutationKey: 'billingDetailReq',
    onError: (error: Error) => openNotification('error', error.message),
  });
  const getClientCoreInfo = useQuery('getClientCoreInfo', () => getCoreInfo(), {
    onError: () => openNotification('error', `Can't get previous license info`),
  });
  const handleStripe = async (event: FormEvent) => {
    setProcessing(true);
    stripe
      ?.confirmCardPayment(invoice?.clientSecret as string, {
        payment_method: {
          card: elements?.getElement(CardNumberElement) as StripeCardNumberElement,
        },
      })
      .then((res: any) => {
        if (res.error) {
          setProcessing(false);
          openNotification('error', `Payment failed ${res.error.message}`);
          history.goBack();
        } else {
          setProcessing(false);
          openNotification('success', `Payment Confirmed`);
          const paymentIntentData = {
            ...res?.paymentIntent,
          };
          stripeRespDetail.mutate(paymentIntentData);
          history.goBack();
        }
      })
      .catch((error) => {
        setProcessing(false);
        openNotification('error', `Payment failed ${error.message}`);
        history.goBack();
      });
  };
  useAppPreloader(processing || billingDetailReq.isLoading || getClientCoreInfo.isLoading);
  const { control, handleSubmit } = useForm<BillingInput>();
  const onsubmit = (e: any) => {
    const arr: any[] = [];
    const invoicesData: string[] = emails.split(',');
    arr.push(invoicesData);
    const trimArray = arr.flat().map((element: any) => element.trim());
    if (previewType === 'card') {
      const invoiceBillingDetail = {
        billingAddress: cardaddress,
        cardHolderName: cardName,
      };
      handleStripe(e);
      billingDetailReq.mutate(invoiceBillingDetail);
    } else {
      const invoiceBillingDetail = {
        billingAddress: cardaddress,
        cardHolderName: cardName,
        invoiceEmail: trimArray,
      };
      billingDetailReq.mutate(invoiceBillingDetail);
    }
  };
  const handleValidation = (e: any) => {
    const reg = new RegExp(/^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/);
    setValid(reg.test(e.target.value));
    setInvoiceEmail(e.target.value);
  };
  return (
    <>
      <form onSubmit={handleSubmit(onsubmit)}>
        <Grid className={classes.formDesign} item xs={12}>
          <Controller
            defaultValue={cardName}
            name='cardHolderName'
            control={control}
            render={({ field, fieldState: { invalid } }) => (
              <>
                <FormLabel className={classes.formText}>Name on the Credit Card</FormLabel>
                <Grid container className={classes.manulInput}>
                  <FormControl className={classes.inputText}>
                    <TextField
                      defaultValue={cardName}
                      onChange={(e: any) => setCardName(e.target.value)}
                      placeholder='Enter name'
                      variant='standard'
                      required
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </FormControl>
                </Grid>
              </>
            )}
          />
        </Grid>
        <Grid className={classes.formDesign} item xs={12}>
          <Controller
            name='billingAddress'
            defaultValue={cardaddress}
            control={control}
            render={({ field, fieldState: { invalid } }) => (
              <>
                <FormLabel className={classes.formText}>Billing Address</FormLabel>
                <Grid container className={classes.manulInput}>
                  <FormControl className={classes.inputText}>
                    <TextField
                      defaultValue={cardaddress}
                      placeholder='Enter billing address'
                      onChange={(e: any) => setCardAddress(e.target.value)}
                      variant='standard'
                      required
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </FormControl>
                </Grid>
              </>
            )}
          />
        </Grid>
        {previewType === 'card' ? (
          <>
            <FormGroup className={classes.formDesign}>
              <FormLabel className={classes.formText}>Card Number</FormLabel>
              <CardNumberElement className={classes.stripeStyle} options={cardStyle} />
            </FormGroup>
            <FormGroup className={classes.formDesign}>
              <FormLabel className={classes.formText}>Card Expirey</FormLabel>
              <CardExpiryElement className={classes.stripeStyle} options={cardStyle} />
            </FormGroup>
            <FormGroup className={classes.formDesign}>
              <FormLabel className={classes.formText}>Card CVC</FormLabel>
              <CardCvcElement className={classes.stripeStyle} options={cardStyle} />
            </FormGroup>
          </>
        ) : (
          <Grid className={classes.formDesign} item xs={12}>
            <Controller
              name='invoiceEmail'
              control={control}
              render={({ field, fieldState: { invalid } }) => (
                <>
                  <FormLabel className={classes.formText}>Send Invoice to Email </FormLabel>
                  <Grid container className={classes.manulInput}>
                    <FormControl className={classes.inputText}>
                      <TextField
                        placeholder='Enter comma seprated emails'
                        required
                        onChange={(e: any) => handleValidation(e)}
                        variant='standard'
                        error={!valid}
                        helperText={!valid ? 'Please enter valid comma separated email address' : ' '}
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </FormControl>
                  </Grid>
                </>
              )}
            />
          </Grid>
        )}

        <CardPreview
          users={numberOfUsers}
          coreCheckHandle={coreCheckHandle}
          addonCheckHandle={addonCheckHandle}
          currentCoreUsers={coreCheckHandle ? numberOfUsers : 0}
          currentAddonUsers={addonCheckHandle ? userAddon || numberOfUsers : 0}
          totalUsers={numberOfUsers}
        />
        <div className={classes.price}>
          <span className={classes.textBox}> Total Price: </span>{' '}
          <span>${finalAmount || toFormatSum(invoice?.amount)} USD</span>
        </div>

        <Grid className={classes.payButton}>
          <Button className={classes.btn1} type='submit' disabled={previewType !== 'card' && !valid}>
            Pay
          </Button>
        </Grid>
      </form>
    </>
  );
};
